export default [
  {
    /**
     * 分页查询标的物信息
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'pageQuerySubjectData',
    method: 'post',
    url: '/finhub/front/subjectData/pageQuerySubjectData',
  },
  {
    /**
     * 查询标的物详情
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'subjectDataDetail',
    method: 'post',
    url: '/finhub/front/subjectData/subjectDataDetail',
  },
  {
    /**
     * 标的物融资申请
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'subjectDataFinanceApply',
    method: 'post',
    url: '/finhub/front/finance/subjectDataFinanceApply',
  },
  {
    /**
     * 	产品融资申请
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'productFinanceApply',
    method: 'post',
    url: '/finhub/front/finance/command/productFinanceApply',
  },
  {
    /**
     * 查询融资流程
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'queryFinanceFlow',
    method: 'post',
    url: '/finhub/front/finance/query/queryFinanceFlow',
  },
  {
    /**
     * 查询融资单可选产品list
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'queryFinanceProductOption',
    method: 'post',
    url: '/finhub/front/finance/query/queryFinanceProductOption',
  },
  {
    /**
     * 分页查询融资单可选标的物
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'pageQueryFinanceSubjectDataOption',
    method: 'post',
    url: '/finhub/front/finance/query/pageQueryFinanceSubjectDataOption',
  },
  {
    /**
     * 融资单绑定标的物
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'financeBindSubjectData',
    method: 'post',
    url: '/finhub/front/finance/command/financeBindSubjectData',
  },
  {
    /**
     * 查询融资单可选产品list
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'financeBindProduct',
    method: 'post',
    url: '/finhub/front/finance/command/financeBindProduct',
  },
  {
    /**
     * 查询融资单可选产品list
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'financeBindProduct',
    method: 'post',
    url: '/finhub/front/finance/command/financeBindProduct',
  },
  {
    /**
     * 查询融资单可选产品list
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'getFinanceByFinanceNo',
    method: 'post',
    url: '/finhub/front/finance/query/getFinanceByFinanceNo',
  },
  {
    /**
     * 查询融资单可选产品list
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'rollbackFinanceAttachment',
    method: 'post',
    url: '/finhub/front/finance/command/rollbackFinanceAttachment',
  },
  {
    /**
     * 	标的物融资单申请记录
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'pageQueryFinanceSubjectData',
    method: 'post',
    url: '/finhub/front/finance/query/pageQueryFinanceSubjectData',
  },
  {
    /**
     * 	确认提交融资单到金融机构
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'confirmFinanceSubmitAgency',
    method: 'post',
    url: '/finhub/front/finance/command/confirmFinanceSubmitAgency',
  },
  {
    /**
     * 	核心企业
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'subjectDataSelectCoreEnterprise',
    method: 'post',
    url: '/finhub/front/subjectData/subjectDataSelectCoreEnterprise',
  },
  {
    /**
     * 	上传附件
     * http://mock.jdfmgt.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9bb3ff54b57a7351ffe79
     */
    name: 'uploadingFinanceAttachment',
    method: 'post',
    url: '/finhub/front/finance/command/uploadingFinanceAttachment',
  },
]
